import React from "react";

import {useNavigate} from 'react-router-dom';

import {Colors} from "../../assets/Colors";

const WorkshopPage = ({}) => {
    const navigate = useNavigate();
    return (
        <div className="md:ml-64">
            <div className="w-full flex flex-col items-center">
                <div className="w-full px-4 my-4 ">
                    <div style={{borderColor: Colors.primary}} className="flex flex-col border rounded">
                        <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                            <div
                                // onClick={() => navigate('/penyusutan')}
                                className="w-full md:w-1/4 cursor-pointer">
                                <div style={{borderColor: Colors.primary}}
                                     className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded">
                                    <p className="pl-2">Workshop</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkshopPage;
